<app-cardholder-details
  *ngIf="cardholder"
  [cardholder]="cardholder"
  (newCardholderSelected)="showNewCardholder($event)"
>
</app-cardholder-details>

<form
  name="financialAdjustmentsForm"
  [formGroup]="financialAdjustmentsForm"
  *ngIf="hasEntitlements('CARDHOLDERS_ADJUSTMENTS_FINANCIAL_ADJUSTMENTS')"
  novalidate
>
  <div id="bulkCardsDetails" class="card card-nc">
    <div class="card-heading ">
      <div class="col-md-5 zeroPadding">
        <i class="fa fa-credit-card"></i>
        <span class="panelHeaderHeading"> FINANCIAL ADJUSTMENTS </span>
      </div>
      <span class="pull-right confirm-combo">
        <app-confirm-button-combo
          [baseLabel]="' TRANSFER '"
          (confirmSelected)="applyAdjustment($event)"
          (baseButtonClicked)="adjustmentTransferClicked()"
          [commit_btn_spinner]="commitButtonSpinnerString"
          [formGroup]="financialAdjustmentsForm"
        >
        </app-confirm-button-combo>
      </span>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-4 zeroPadding">
          <label
            for="adjustReason"
            class="col-md-12 control-label labelCommon text-nowrap"
          >
            Adjustment Reason
          </label>
          <div class="form-group col-md-12">
            <select
              class="form-control input-sm"
              id="adjustReason"
              formControlName="adjustReason"
            >
              <option
                *ngFor="let adjustmentReason of adjustmentReasons"
                value="{{ adjustmentReason.COLUMN_VALUE }}"
              >
                {{ adjustmentReason.DESCR }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-4 zeroPadding">
          <label
            for="adjustAmt"
            class="col-md-12 control-label labelCommon text-nowrap"
          >
            Adjustment Amount
          </label>
          <div class="form-group col-md-12">
            <input
              type="text"
              class="form-control input-sm"
              id="adjustAmt"
              formControlName="adjustAmt"
              placeholder="0.00"
              maxlength="11"
              required
              [ngClass]="{
                'has-error':
                  finAdjFormHandle.adjustAmt.invalid &&
                  finAdjFormHandle.adjustAmt.touched
              }"
            />
            <span
              class="help-block has-error validationMessage"
              *ngIf="
                !finAdjFormHandle.adjustAmt.valid &&
                finAdjFormHandle.adjustAmt.touched
              "
            >
              <span *ngIf="finAdjFormHandle.adjustAmt.errors?.pattern">
                Amount is not valid
              </span>
              <span *ngIf="finAdjFormHandle.adjustAmt.errors?.required">
                Required
              </span>
              <span *ngIf="finAdjFormHandle.adjustAmt.errors?.maxlength">
                Amount can only be 11 characters
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<form
  name="balanceTransferForm"
  [formGroup]="balanceTransferForm"
  *ngIf="hasEntitlements('CARDHOLDERS_ADJUSTMENTS_BALANCE_TRANSFER')"
  novalidate
>
  <div class="card card-nc">
    <div class="card-heading ">
      <div class="col-md-5 zeroPadding">
        <i class="fa fa-exchange"></i>
        <span class="panelHeaderHeading"> BALANCE TRANSFER </span>
      </div>
      <span class="pull-right confirm-combo">
        <app-confirm-button-combo
          [baseLabel]="' TRANSFER '"
          (confirmSelected)="applyBalance($event)"
          (baseButtonClicked)="balanceTransferClicked()"
          [commit_btn_spinner]="applyBalanceButtonSpinnerString"
          [formGroup]="balanceTransferForm"
        >
        </app-confirm-button-combo>
      </span>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-4 zeroPadding">
          <label
            for="srcAcct"
            class="col-md-12 control-label labelCommon text-nowrap"
          >
            Source Account Number
          </label>
          <div class="form-group col-md-12">
            <select
              class="form-control input-sm"
              id="srcAcct"
              formControlName="srcAcct"
            >
              <option
                *ngFor="let srcAcct of srcAccts"
                value="{{ srcAcct.value }}"
              >
                {{ srcAcct.label }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-4 zeroPadding">
          <label
            for="desAcct"
            class="col-md-12 control-label labelCommon text-nowrap"
          >
            Destination Account Number
          </label>
          <div class="form-group col-md-12">
            <input
              type="text"
              class="form-control input-sm"
              id="desAcct"
              formControlName="desAcct"
              maxlength="16"
              required
              [ngClass]="{
                'has-error':
                  balTransFormHandle.desAcct.invalid &&
                  balTransFormHandle.desAcct.touched
              }"
            />
            <span
              class="help-block has-error validationMessage"
              *ngIf="
                !balTransFormHandle.desAcct.valid &&
                balTransFormHandle.desAcct.touched
              "
            >
              <span *ngIf="balTransFormHandle.desAcct.errors?.pattern">
                Number is not valid
              </span>
              <span *ngIf="balTransFormHandle.desAcct.errors?.required">
                Required
              </span>
              <span *ngIf="balTransFormHandle.desAcct.errors?.maxlength">
                Number can only be 16 characters
              </span>
            </span>
          </div>
        </div>
        <div class="col-md-4 zeroPadding">
          <label for="xferAmt" class="col-md-12 control-label labelCommon">
            Transfer Amount
          </label>
          <div class="form-group col-md-12">
            <input
              type="text"
              class="form-control input-sm"
              id="xferAmt"
              formControlName="xferAmt"
              placeholder="0.00"
              maxlength="10"
              required
              [ngClass]="{
                'has-error':
                  balTransFormHandle.xferAmt.invalid &&
                  balTransFormHandle.xferAmt.touched
              }"
            />
            <span
              class="help-block has-error validationMessage"
              *ngIf="
                !balTransFormHandle.xferAmt.valid &&
                balTransFormHandle.xferAmt.touched
              "
            >
              <span *ngIf="balTransFormHandle.xferAmt.errors?.pattern">
                Number is not valid
              </span>
              <span *ngIf="balTransFormHandle.xferAmt.errors?.required">
                Required
              </span>
              <span *ngIf="balTransFormHandle.xferAmt.errors?.maxlength">
                Transfer amount can only be 10 characters
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="whitePanelRow labelBlueBold" *ngIf="transferSummary">
  BALANCE TRANSFER DETAILS
  <div class="row">
    <label class="col-md-4">&nbsp;</label>
    <label class="col-md-4 control-label labelBlueBold"> Source </label>
    <label class="col-md-4 control-label labelBlueBold"> Destination </label>
  </div>
  <div class="row borderLine">
    <label class="col-md-4 labelCommon">Client Account Number</label>
    <div class="col-md-4 staticText3">{{ transferSummary.srcClntAcct }}</div>
    <div class="col-md-4 staticText3">{{ transferSummary.desClntAcct }}</div>
  </div>
  <div class="row borderLine">
    <label class="col-md-4 labelCommon"> Account Number </label>
    <div class="col-md-4 staticText3">{{ transferSummary.srcAcct }}</div>
    <div class="col-md-4 staticText3">{{ transferSummary.desAcct }}</div>
  </div>
  <div class="row borderLine">
    <label class="col-md-4 labelCommon"> Account Holder Name </label>
    <div class="col-md-4 staticText3">{{ transferSummary.srcName }}</div>
    <div class="col-md-4 staticText3">{{ transferSummary.desName }}</div>
  </div>
  <div class="row borderLine">
    <label class="col-md-4 labelCommon"> SSN </label>
    <div class="col-md-4 staticText3">{{ transferSummary.srcSsn4 }}</div>
    <div class="col-md-4 staticText3">{{ transferSummary.desSsn4 }}</div>
  </div>
  <div class="row borderLine">
    <label class="col-md-4 labelCommon"> Amount Transferred </label>
    <div class="col-md-8 staticText3">
      {{ transferSummary.amount | currency }}
    </div>
  </div>
  <div class="row">
    <label class="col-md-4 labelCommon"> Current Balance </label>
    <div class="col-md-4 staticText3">
      {{ transferSummary.srcBal | currency }}
    </div>
    <div class="col-md-4 staticText3">
      {{ transferSummary.desBal | currency }}
    </div>
  </div>
</div>
